<template>
  <div
    class="select relative h-full hover:text-primary font-bold dark:text-dark-text-dark"
    :class="windowWidth >= 1600 ? 'ml-4' : 'ml-4'"
    style="transition: color 0.5s"
    v-on:mouseleave="nested.hide.value = true"
    v-on:mouseover="nested.hide.value = false"
  >
    <div class="h-full flex items-center justify-center">
      <img
        v-if="titleImage != undefined"
        alt="user icon"
        class="border rounded-full object-cover"
        :class="[windowWidth >= 1600 ? 'image-style' : 'image-style-mini']"
        :src="titleImage"
      />
      <span
        v-else-if="titleIcon != ''"
        class="material-icons"
        :class="[windowWidth >= 1600 ? 'image-style' : 'image-style-mini']"
      >
        {{ titleIcon }}
      </span>
      <div
        class="ml-2 whitespace-nowrap"
        :class="windowWidth >= 1600 ? 'text-lg' : 'text-base'"
        style="margin-top: 2px"
      >
        {{ titleText }}
      </div>
      <svg
        class="fill-current"
        :class="windowWidth >= 1600 ? 'w-6 h-6 ml-1' : 'w-4 h-4 ml-1'"
        style="float: right; margin-top: 2px"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
      </svg>
    </div>
    <Transition name="slide-fade">
      <ul v-show="!nested.hide.value" class="shadow-xl drop-card">
        <li v-for="(menuText, index) in menuTextList" :key="index">
          <button
            class="drop-card-item border-r border-l"
            :class="[
              {
                'list-round-first border-t': index === 0,
                'list-round-last border-b': index === menuTextList.length - 1
              },
              `${itemPY}`
            ]"
            @click="menuClickList[index]"
          >
            <span
              v-if="menuIconList.length > 0"
              class="material-icons mr-4 ml-2 my-auto"
              :class="{
                'text-xl': windowWidth >= 1600,
                'text-sm': windowWidth < 1600
              }"
            >
              {{ menuIconList[index] }}
            </span>
            <div class="text-sm my-auto" :class="{ 'ml-1': menuIconList.length <= 0 }">
              {{ menuText }}
            </div>
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  name: 'HeaderDropDownMenu',
  props: {
    titleText: {
      type: String,
      required: true
    },
    titleIcon: {
      type: String,
      default: ''
    },
    titleImage: {
      type: String
    },
    menuTextList: {
      type: Array as () => string[],
      required: true
    },
    menuIconList: {
      type: Array,
      default: () => []
    },
    menuClickList: {
      type: Array,
      required: true
    },
    itemPY: {
      type: String,
      default: 'py-3'
    }
  },
  setup(props, ctx) {
    const { windowWidth } = useConfigStatePresenter()
    const hide = ref(true)

    const maxTextLength = computed(() => {
      return Math.max(...props.menuTextList.map(item => item.length))
    })

    return {
      windowWidth,
      maxTextLength,
      nested: {
        hide
      }
    }
  }
})
</script>

<style lang="postcss" scoped>
.drop-card {
  @apply z-10 mt-3 absolute;
  top: 3.6rem;
  left: -0.4rem;
  border-radius: 1rem;
}

.drop-card-item {
  @apply w-full pl-3 pr-5 inline-flex cursor-pointer bg-white text-gray-800 dark:bg-dark-200 dark:text-dark-text  dark:border-dark-200 whitespace-nowrap;
  min-width: 200px;
  &:hover {
    @apply bg-primary-50 dark:bg-dark-10;
  }
}

.image-style {
  @apply cursor-pointer;
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.image-style-mini {
  @apply cursor-pointer;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
</style>
